export default __webpack_public_path__ + "static/SHI-cae5763a0beca6bdbd5af79ce5983c21.jpg";